import React from 'react';
import { Node } from '@uncinc/react-drupal-core';

const TestimonialOverview = ({ entities }) => {
  return (
    <div className="TestimonialOverview">
      <div className="row">
        {entities.map((entity) => {
          const id = entity.getIn(['nid', '0', 'value']);
          const uuid = entity.getIn(['uuid', 0, 'value']);
          const langcode = entity.getIn(['langcode', 0, 'value']);

          return (
            <Node
              id={id}
              key={`${uuid}:${langcode}`}
              entity={entity}
              viewMode="small"
              className="col-12 col-md-4"
            />
          );
        })}
      </div>
    </div>
  );
};

export default TestimonialOverview;
